var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9432 6.08181C11.0473 5.97872 11.1879 5.9209 11.3344 5.9209C11.4809 5.9209 11.6215 5.97872 11.7256 6.08181C11.777 6.13242 11.8179 6.19276 11.8457 6.2593C11.8736 6.32585 11.8879 6.39727 11.8879 6.46941C11.8879 6.54155 11.8736 6.61296 11.8457 6.67951C11.8179 6.74605 11.777 6.80639 11.7256 6.85701L8.59923 9.92101C8.49489 10.0239 8.35421 10.0817 8.20763 10.0817C8.06106 10.0817 7.92038 10.0239 7.81603 9.92101L4.68963 6.85701C4.63823 6.80639 4.59742 6.74605 4.56955 6.67951C4.54169 6.61296 4.52734 6.54155 4.52734 6.46941C4.52734 6.39727 4.54169 6.32585 4.56955 6.2593C4.59742 6.19276 4.63823 6.13242 4.68963 6.08181C4.79374 5.97872 4.93433 5.9209 5.08083 5.9209C5.22734 5.9209 5.36793 5.97872 5.47203 6.08181L8.20883 8.59461L10.9432 6.08181Z",
    fill: "#D1D4D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChevronLeft);
export default __webpack_public_path__ + "static/media/icons-chevron-left.46803e3eeb23e1cab3a7fb62c8ce373e.svg";
export { ForwardRef as ReactComponent };